// Lessons unlock weekly on Mondays at 12:00 PM Eastern Time.
// First release: Monday, July 6, 2026 at 12:00 PM ET (EDT = UTC-4) → 16:00 UTC.
// Each subsequent lesson (by order_index) unlocks the following Monday at noon ET.

const FIRST_RELEASE_UTC_MS = Date.UTC(2026, 6, 6, 16, 0, 0); // July 6, 2026 16:00 UTC
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export const releaseDateForOrderIndex = (orderIndex: number): Date =>
  new Date(FIRST_RELEASE_UTC_MS + Math.max(0, orderIndex) * WEEK_MS);

export const isReleased = (orderIndex: number, now: Date = new Date()): boolean =>
  now.getTime() >= releaseDateForOrderIndex(orderIndex).getTime();

export const formatReleaseDate = (orderIndex: number): string => {
  const d = releaseDateForOrderIndex(orderIndex);
  return d.toLocaleString("en-US", {
    timeZone: "America/New_York",
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  });
};
